<ng-container *ngIf="visible">

    <mat-progress-bar color="primary" [bufferValue]="bufferValue" [mode]="mode" [value]="value"></mat-progress-bar>

</ng-container>
